/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';
import { UpdateDisplayInfoDto } from '../../models/update-display-info-dto';

export interface DeviceControllerUpdateDisplayInfo$Params {
  id: string;
      body: UpdateDisplayInfoDto
}

export function deviceControllerUpdateDisplayInfo(http: HttpClient, rootUrl: string, params: DeviceControllerUpdateDisplayInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerUpdateDisplayInfo.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceDto>;
    })
  );
}

deviceControllerUpdateDisplayInfo.PATH = '/api/device/{id}/display-info';
